module.exports = __webpack_public_path__ + "img/gallery-2.fd790745.jpg";